export enum BillingPlatform {
  CHARGIFY = 'chargify',
  MAXIO = 'maxio',
}
